import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
 SnmpV3User, API_PATH_SNMP_USERS, SnmpDestination, API_PATH_SNMP_DESTS
} from './snmp.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getSnmpUsers(
  deliveryFunctionId: string
): AxiosPromise<ServerResponse<SnmpV3User>> {
  return http.get(`${API_PATH_SNMP_USERS}/${deliveryFunctionId}`);
}

export function getSnmpUserById(
  deliveryFunctionId: string,
  id: string
): AxiosPromise<ServerResponse<SnmpV3User>> {
  return http.get(`${API_PATH_SNMP_USERS}/${deliveryFunctionId}/${id}`);
}

export function createSnmpUser(
  deliveryFunctionId: string,
  body: WithAuditDetails<SnmpV3User>
) {
  return http.post(`${API_PATH_SNMP_USERS}/${deliveryFunctionId}`, body);
}

export function deleteSnmpUserById(deliveryFunctionId: string, id: string, body: WithAuditDetails<void>) {
  return http.delete(`${API_PATH_SNMP_USERS}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}

export function updateSnmpUser(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<SnmpV3User>
) {
  return http.put(`${API_PATH_SNMP_USERS}/${deliveryFunctionId}/${id}`, body);
}

export function getSnmpDests(
  deliveryFunctionId: string
): AxiosPromise<ServerResponse<SnmpDestination>> {
  return http.get(`${API_PATH_SNMP_DESTS}/${deliveryFunctionId}`);
}

export function getSnmpDestById(
  deliveryFunctionId: string,
  id: string
): AxiosPromise<ServerResponse<SnmpDestination>> {
  return http.get(`${API_PATH_SNMP_DESTS}/${deliveryFunctionId}/${id}`);
}

export function createSnmpDest(
  deliveryFunctionId: string,
  body: WithAuditDetails<SnmpDestination>
) {
  return http.post(`${API_PATH_SNMP_DESTS}/${deliveryFunctionId}`, body);
}

export function deleteSnmpDestById(deliveryFunctionId: string, id: string, body: WithAuditDetails<void>) {
  return http.delete(`${API_PATH_SNMP_DESTS}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}

export function updateSnmpDest(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<SnmpDestination>
) {
  return http.put(`${API_PATH_SNMP_DESTS}/${deliveryFunctionId}/${id}`, body);
}
